import Proxy from '../lib/Proxy.js';
import UrlParams from './UrlParams.js';
import Decorator from '../lib/Decorator.js';
import Observable from '../lib/Observable.js';
import EnvironmentSize from './EnvironmentSize.js';
import MaintenanceWindow from './MaintenanceWindow.js';
import DialogController from '../ui/DialogController.js';

class Environment {
    static create(params) {
        return new Environment(params);
    }

    static withDefaults(params = {}) {
        var defaults = {
            loginDown: window.loginDown,
            maintenanceStart: window.downtime,
            proxy: Proxy.create(),
            queryString: location.search,
            referrer: document.referrer,
            userAgent: navigator.userAgent,
            isTouchScreen: navigator.maxTouchPoints > 0,
            screenSize: {height: screen.height, width: screen.width}
        };

        return this.create({...defaults, ...params});
    }

    constructor({proxy, referrer, loginDown, queryString, userAgent, isTouchScreen, screenSize, maintenanceStart}) {
        this.proxy = proxy;
        this.referrer = referrer;
        this.loginDown = loginDown;
        this.userAgent = userAgent;
        this.isTouchScreen = isTouchScreen;
        this.urlParams = UrlParams.create(queryString);
        this.dialogController = DialogController.create({env: this});
        this.environmentSize = EnvironmentSize.create({screenSize});
        this.maintenanceWindow = MaintenanceWindow.create({urlParams: this.urlParams, maintenanceStart});
        this.nav = Observable.create();
        this.decorator = Decorator.create();

        this.homepageUrl = 'https://simplyanalytics.com/';
        this.userPasswordRegex = /^\S{6,}$/;
        this.simplyAnalyticsReferrerRegex = /^https?:\/\/simplyanalytics.com\//;
        this.emailRegex = /^(")?(?:[^\."])(?:(?:[\.])?(?:[\w\-!#$%&'*+/=?^_`{|}~]))*\1@(\w[\-\w]*\.){1,5}([A-Za-z]){2,6}$/;
    }

    clearNonSACookies() {
        var cookies = document.cookie.match(/\w+=/g) ?? [];

        cookies.filter(cookie => cookie !== 'sa_session=') 
            .forEach(cookie => document.cookie = `${cookie.slice(0, -1)}=; expires=Thu, 01-Jan-70 00:00:01 GMT; path=/`);
    }

    getDecorator() {
        return this.decorator;
    }

    getDialog(id) {
        return this.dialogController.get(id);
    }

    getInstitution() {
        return this.institution;
    }

    getLastActiveTimeStamp() {
        var value = localStorage.getItem('lastActive');

        return value === null ? null : Number(value);
    }

    getMaintenanceWindow() {
        return this.maintenanceWindow;
    }

    getProxy() {
        return this.proxy;
    }

    getReferrer() {
        return this.referrer;
    }

    getUrlParams() {
        return this.urlParams;
    }

    hasSimplyAnalyticsReferrer() {
        return this.simplyAnalyticsReferrerRegex.test(this.getReferrer());
    }

    hideCurrentDialog() {
        this.dialogController.hideCurrent();
    }

    isLoginDown() {
        return this.loginDown;
    }

    isMobile() {
        return this.userAgent.includes('Mobile')
            || this.userAgent.includes('Android')
            || (this.userAgent.includes('Linux') && this.isTouchScreen) 
            || (this.userAgent.includes('Mac OS X') && this.isTouchScreen); 
    }

    isSmallDesktopBrowser() {
        return this.environmentSize.isSmallDesktopBrowser();
    }

    isSmallDesktopScreen() {
        return this.environmentSize.isSmallDesktopScreen();
    }

    isValidEmail(email) {
        return this.emailRegex.test(email);
    }

    isValidUserPassword(password) {
        return this.userPasswordRegex.test(password);
    }

    navTo(...args) {
        this.nav.trigger(...args);
    }

    onNav(...args) {
        this.nav.on(...args);
    }

    open(href) {
        window.location.assign(href);
    }

    openHomepage() {
        this.open(this.homepageUrl);
    }

    openReferrer() {
        this.open(this.getReferrer());
    }

    reloadPage() {
        window.location.reload();
    }

    reloadPageWithoutParams() {
        this.open(window.location.pathname);
    }

    setInstitution(institution) {
        this.institution = institution;
        return this;
    }

    showDialog(id) {
        return this.getDialog(id).show();
    }
}

export default Environment;